/**
 * THE TWO ORNAMENTS, AND WHY THERE ARE ONLY TWO.
 *
 * Both are drawn from the same source as the page's ground pattern: Persian
 * girih strapwork. Using one geometry at three scales — background tile,
 * section glyph, hero rosette — is what makes this read as a system rather
 * than as three separate decorations.
 *
 * TEN POINTS, NOT EIGHT. The first version of the rosette was two eight-point
 * stars set 22.5° apart, and the overlap read as a six-pointed star — a shape
 * that carries meaning this marketplace is not making a statement about. The
 * ده‌پر (ten-point) rosette is the other canonical girih figure, it is
 * unambiguously Persian, and no pair of its chords forms a hexagram. Drawn as
 * one continuous twenty-vertex path so there is nothing to overlap.
 *
 * These are inline SVG, not image files: small, `currentColor` so a single
 * CSS token themes them for light and dark, and no request on the critical
 * path. Server components on purpose — nothing here is interactive, so none
 * of it should reach the client bundle.
 */

/** The ده‌پر rosette behind the hero headline. */
export function Rosette({ className }: { className?: string }) {
  const star =
    "M100.0 6.0 L117.9 44.8 L155.3 24.0 L146.9 65.9 L189.4 71.0 L158.0 100.0 L189.4 129.0 L146.9 134.1 L155.3 176.0 L117.9 155.2 L100.0 194.0 L82.1 155.2 L44.7 176.0 L53.1 134.1 L10.6 129.0 L42.0 100.0 L10.6 71.0 L53.1 65.9 L44.7 24.0 L82.1 44.8 Z";
  return (
    <svg className={className} viewBox="0 0 200 200" fill="none" aria-hidden focusable="false">
      <g stroke="currentColor" fill="none" strokeWidth="0.8" strokeLinejoin="round">
        <circle cx="100" cy="100" r="96" strokeWidth="0.5" />
        <path d={star} />
        <circle cx="100" cy="100" r="58" strokeWidth="0.5" />
        <circle cx="100" cy="100" r="26" strokeWidth="0.5" />
      </g>
    </svg>
  );
}

/**
 * The small mark that opens every section title, and the brand mark in the
 * chrome. A five-fold knot — the ten-point rosette's own unit cell — so the
 * identity, the section rule and the hero figure are all the same geometry.
 */
export function SecGlyph({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 16 16" fill="none" aria-hidden focusable="false">
      <g stroke="currentColor" strokeWidth="1.1" fill="none" strokeLinejoin="round">
        <path d="M8 1 L14.7 5.9 L12.1 13.8 L3.9 13.8 L1.3 5.9 Z" />
        <path d="M8 5.4 L11 7.6 L9.9 11.1 L6.1 11.1 L5 7.6 Z" />
      </g>
    </svg>
  );
}
